import e from"./SearchBox.vue_vue&type=script&lang.js";import{render as r}from"./SearchBox.vue_vue&type=template&id=27029d83&lang.js";e.render=r,e.__file="src/components/SearchBox.vue";export default e;
//# sourceMappingURL=SearchBox.vue.js.map
